/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_CtaInputs */

const en_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try it free`)
};

const de_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos ausprobieren`)
};

const zh_tw_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去免費試試看`)
};

const zh_cn_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去免费试试看`)
};

const es_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo gratis`)
};

const fr_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayer gratuitement`)
};

const it_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provalo gratis`)
};

const pt_br_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente grátis`)
};

const ja_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で試してみる`)
};

const ko_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 써보기`)
};

const ru_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать бесплатно`)
};

const th_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองใช้ฟรีเลย`)
};

const tr_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz dene`)
};

const ar_closing_cta = /** @type {(inputs: Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جرّبه مجانًا`)
};

/**
* | output |
* | --- |
* | "Try it free" |
*
* @param {Closing_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_cta = /** @type {((inputs?: Closing_CtaInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_CtaInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_cta(inputs)
	if (locale === "de") return de_closing_cta(inputs)
	if (locale === "zh_tw") return zh_tw_closing_cta(inputs)
	if (locale === "zh_cn") return zh_cn_closing_cta(inputs)
	if (locale === "es") return es_closing_cta(inputs)
	if (locale === "fr") return fr_closing_cta(inputs)
	if (locale === "it") return it_closing_cta(inputs)
	if (locale === "pt_br") return pt_br_closing_cta(inputs)
	if (locale === "ja") return ja_closing_cta(inputs)
	if (locale === "ko") return ko_closing_cta(inputs)
	if (locale === "ru") return ru_closing_cta(inputs)
	if (locale === "th") return th_closing_cta(inputs)
	if (locale === "tr") return tr_closing_cta(inputs)
	return ar_closing_cta(inputs)
});